import React, {useEffect, useState} from 'react';
import {PcPayMethodsPopup} from './pc/PcPayMethodsPopup';
import {MobilePayMethodsPopup} from "./mobile/MobilePayMethodsPopup";
import {createSubscriptionRequest} from "../../../../../../utils/api";
import {PAYMENT_TYPE_PAYPAL, PAYMENT_TYPE_STRIPE} from "../../../../../../const/Pay";
import {SKU_INFO} from "../../../../../../const/LocalStorage";
import {getLoading} from "../../../../../../utils/loading";

function PayMethodsPopup({clicked, clickNext, isMobile, ...props}) { // 接收 isMobile props
    const {price, closePopup, weightLossFormData, logEvent, discount} = props;
    if (!price) {
        return ;
    }

    // 支付方式选择埋点方法
    const logPaymentMethodClick = (paymentType) => {
        const skuValue =  paymentType === PAYMENT_TYPE_PAYPAL ?  price?.sku?.paypal : price?.sku?.stripe;
        const isWallet = false; // 根据实际业务逻辑判断是否为钱包支付
        
        logEvent(paymentType === PAYMENT_TYPE_PAYPAL
            ? "paypal_click"
            : isWallet
                ? "wallet_click"
                : "stripe_click", { 
                    sku: skuValue,
                    string2: price?.getUniqueId() || "", // SKU ID
                    percent: discount // discount percentage
                }, "pay", true); // instantly = true
    };

    const clickPaypalPay = async () => {
        const loading = getLoading();
        
        try {
            loading.show();
            
            const sku = price?.sku?.paypal;
            const [sessionId, clientSecret, sessionUrl] = await createSubscriptionRequest(sku, weightLossFormData.email, price.getDiscountValueForServer(), price.dynamicCycleSubscription, PAYMENT_TYPE_PAYPAL);
            
            if (sessionUrl) {
                localStorage.setItem(SKU_INFO, JSON.stringify({
                    sku: sku,
                    sku_id: price?.getUniqueId() || "",
                    session_id: sessionId,
                    payment_type: PAYMENT_TYPE_PAYPAL,
                    discount: discount, // discount percentage
                    price: price?.getPrice() || "",
                    week: price?.week
                }));
                
                logEvent("createsuccess_exposure", {
                    type: PAYMENT_TYPE_PAYPAL + "",
                    sku: sku,
                    percent: discount, // discount percentage
                    string2: price?.getUniqueId() || "", // SKU ID
                    string1: price?.getPrice(),
                    string3: price?.week + ""
                }, "pay", true); // instantly = true
                
                // Keep loading visible during redirect
                window.location.href = sessionUrl;
            } else {
                loading.hide();
            }
        } catch (error) {
            loading.hide();
            console.error('PayPal payment error:', error);
            // TODO: show error message to user
        }
    }
    const closePaymentPopup = () => {
        logEvent("closepaypopup_click", {
            sku: JSON.stringify(price?.sku) || "",
            percent: discount, // discount percentage
            string2: price?.getUniqueId() || "" // SKU ID
        }, "pay", true); // instantly = true
        closePopup();
    };

    // 确保 clickNext 和 clickPrev props 被传递，如果未提供则使用空函数作为默认值
    const commonProps = {
        ...props,
        clicked,
        clickPaypalPay,
        closePaymentPopup,
        logPaymentMethodClick,
        clickNext: clickNext || (() => {}),
        clickPrev: props.clickPrev || (() => {})
    };


    if (isMobile) {
     return <MobilePayMethodsPopup {...commonProps} />;
    }
    return <PcPayMethodsPopup {...commonProps} />;
}

export default PayMethodsPopup;